// ##############################
// // // Stepper styles
// #############################

import {
  //customFont,
  primaryColor,
  yellowColor,
  purpleColor,
  redColor,
} from 'assets/styles/jss/main';

const stepperStyle = {
  container: {
    maxWidth: 550,
    minWidth: 270,
    minHeight: '40vh',
    margin: '15px auto',
  },
  title: {
    //...customFont,
    fontSize: '16px',
  },
  finishedContainer: {
    margin: '20px 0',
    textAlign: 'center',
  },
  finishedText: {
    cursor: 'pointer',
    color: primaryColor,
    '&:hover': {
      color: primaryColor,
      fontWeight: 'normal',
    },
  },
  yellow: {
    color: `${yellowColor} !important`,
  },
  purple: {
    color: `${purpleColor} !important`,
  },
  red: {
    color: `${redColor} !important`,
  },
};

export default stepperStyle;
